import React, { FC, useEffect, useState } from "react";
import { Box, Switch, TextField, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import {
  setOtherLandingData,
  setTicketsBundles,
} from "../../../redux/actions/propertyActions";
import dataProvider from "../../../providers/dataProvider";

interface TicketsBoundlesProps {
  pageType: string;
}

interface TicketsBundle {
  tickets: number;
  price: number;
}

export const LandingTicketsBoundles = ({ pageType }: TicketsBoundlesProps) => {
  const dispatch = useDispatch();
  const [bundles, setBundles] = useState<Array<TicketsBundle>>([]);

  const getGeneral = async () => {
    const result = await dataProvider.getLandingGeneral(pageType);
    dispatch(
      setOtherLandingData({
        name: result.data.name,
        landingType: result.data.landingType,
        ticketsBundles: result.data.ticketsBundles,
      }),
    );
    if (result.data.ticketsBundles.length < 2) {
      const defaultArr: Array<TicketsBundle> = [
        { tickets: 2, price: 2 },
        { tickets: 5, price: 2 },
      ];
      setBundles([...defaultArr]);
      dispatch(setOtherLandingData({ ticketsBundles: defaultArr }));
    } else {
      setBundles([...result.data.ticketsBundles]);
    }
  };

  useEffect(() => {
    getGeneral();
  }, []);

  const addItem = () => {
    const ticketsAmount = bundles[bundles.length - 1].tickets + 5;
    const ticketsBundlesArrCopy = [...bundles];
    const item = { tickets: ticketsAmount, price: 2 };
    ticketsBundlesArrCopy.push(item);
    dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
    setBundles([...ticketsBundlesArrCopy]);
  };

  const handleDeleteItem = (index: number) => () => {
    let copyArr = [...bundles];
    const ticketsBundlesArrCopy = [
      ...copyArr.splice(0, index),
      ...copyArr.splice(index + 1),
    ];

    if (ticketsBundlesArrCopy.length === 0) {
      dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
      setBundles([...ticketsBundlesArrCopy]);
      return;
    }
    dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
    setBundles([...ticketsBundlesArrCopy]);
  };

  const handleItem = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    type: string,
  ) => {

    const bundlesArray = [...bundles];
    const value = e.currentTarget.value;
    let item = type === "price" ? "price" : "tickets";

    if (item === "tickets") {
      if (!/^\d*$/.test(value)) return;

      bundlesArray[index] = {
        ...bundlesArray[index],
        tickets: parseInt(value, 10),
      };
    }

    if (item === "price") {
      if (!/^\d*\.?\d*$/.test(value)) return;

      bundlesArray[index] = {
        ...bundlesArray[index],
        price: parseFloat(value),
      };
    }
    dispatch(setOtherLandingData({ ticketsBundles: bundlesArray }));
    setBundles([...bundlesArray]);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography variant="h6">Status</Typography>
      </Box>
      <>
        {bundles.map((item: TicketsBundle, i: number) => {
          return (
            <Box
              display="block"
              className="base-color"
              fontFamily="SF UI Display Light"
            >
              <Box display="flex" alignItems="center">
                <Box paddingRight="1em" whiteSpace="nowrap">
                  Tickets:
                </Box>
                <Box>
                  <Box marginBottom="0.6em" marginRight="0.6em">
                    <TextField
                      type="number"
                      label="count"
                      className="discount-field"
                      value={item.tickets}
                      onChange={(e) => handleItem(e, i, "tickets")}
                      defaultValue={2}
                      required
                    />
                  </Box>
                  {!item && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">Required</div>
                    </Box>
                  )}
                  {i !== 0 && item.tickets <= bundles[i - 1].tickets && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">
                        Should be more than previous value
                      </div>
                    </Box>
                  )}
                  {item.tickets > 1000 && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">
                        Should be less than 1000
                      </div>
                    </Box>
                  )}
                </Box>
                <Box paddingRight="1em" whiteSpace="nowrap">
                  Ticket price:
                </Box>
                <Box>
                  <Box marginBottom="0.6em" marginRight="0.6em">
                    <TextField
                      type="number"
                      label="£"
                      className="discount-field"
                      value={item.price}
                      onChange={(e) => handleItem(e, i, "price")}
                      defaultValue={1}
                      required
                    />
                  </Box>
                  {!item.price && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">Required</div>
                    </Box>
                  )}

                  {item.price <= 0 && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">
                        Should be greater than 0
                      </div>
                    </Box>
                  )}
                </Box>
                <CloseIcon
                  className="remove-discount"
                  onClick={handleDeleteItem(i)}
                />
              </Box>
            </Box>
          );
        })}
        {bundles.length < 2 && (
          <Box marginTop="2em">
            <div className="common-error">
              Tickets bundles amount shouldn't be less then 2
            </div>
          </Box>
        )}
        <AddCircleIcon onClick={addItem} className="add-discount" />
      </>
    </Box>
  );
};
